export default __webpack_public_path__ + "cc4446bc9d319a100e527a4db4618be4.svg";